import Vue from "vue"
import VueSuperagent from "vue-superagent"
import Vuex from "vuex"
import Router from "vue-router"

import "./filters"
import "./mixins"
import storePlugin from "./storePlugin"

import App from "./App.vue"
const Empty = () => import('@/components/Empty.vue');
const Bookmarks = () => import('@/views/Bookmarks.vue');
const Categories = () => import('@/views/Categories.vue');
const Users = () => import('@/views/Users.vue');
const Login = () => import('@/views/Login.vue');
const Logout = () => import('@/views/Logout.vue');
const MissingPictures = () => import('@/views/MissingPictures.vue');

// plugins
import VueNumeric from "vue-numeric"
import BootstrapVue from "bootstrap-vue"
import Datetime from "vue-datetime"

// plugins css
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
import "vue-datetime/dist/vue-datetime.css"

// custom css
import "./assets/css/base.scss"

Vue.use(Vuex)
Vue.use(VueNumeric)
Vue.use(VueSuperagent, {
  baseUrl: "/api"
})
Vue.use(BootstrapVue)
Vue.use(Datetime)
Vue.use(Router)
Vue.use(storePlugin)

const routes = [
  { path: "/", component: Empty },
  { path: "/bookmarks", component: Bookmarks },
  { path: "/bookmarks/:id", name: 'bookmarks', component: Bookmarks },
  { path: "/categories", name: 'categories', component: Categories },
  { path: "/missing_pictures", name: 'missing_pictures', component: MissingPictures },
  { path: "/users", name: 'users', component: Users },
  { path: "/login", name: 'login', component: Login },
  { path: "/logout", name: 'logout', component: Logout },
]

const router = new Router({
  routes,
  mode: "history",
  linkExactActiveClass: "active"
})

new Vue({
  el: "#app",
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js